import React, { useEffect, useRef } from "react";
import SectionHeader from "../section_header/SectionHeader";
import BentoGrid from "@bentogrid/core";
import "./home_projects.scss";
import img6 from "../../assets/projects/ar_residence/img1.webp";
import { getProjectById } from "../../data/ProjectsData";

const HomeProject = () => {
  const gridRef = useRef(null);

  const gavinResidence = getProjectById("r5");
  const coimbatoreElevation = getProjectById("r3");
  const rajaVilla = getProjectById("r8");
  const globalCriticalCare = getProjectById("c4");
  const machoSaloon = getProjectById("c5");
  const miracleWedding = getProjectById("o2");

  const projectsSm = [
    gavinResidence,
    coimbatoreElevation,
    rajaVilla,
    globalCriticalCare,
    machoSaloon,
    miracleWedding,
  ];

  useEffect(() => {
    if (gridRef.current) {
      const gridInstance = new BentoGrid({
        target: gridRef.current,
        cellGap: 10,
        columns: 6,
        aspectRatio: 1.2, // cells are squares
        breakpoints: {
          480: { columns: 2 },
          768: { columns: 4 },
        },
      });

      // Optional: cleanup on unmount
      return () => {};
    }
  }, []);

  return (
    <div className="home_projects_main">
      <div className="home_project_heading">
        <SectionHeader name={"PROJECTS"} />
      </div>
      <div className="home_project_container">
        {window.innerWidth < 768 && (
          <div className="home_project_sm">
            {projectsSm.map((item, index) => (
              <a href={`/projects/${item.id}`} key={index}>
                <h2>{item.name}</h2>
                <div
                  className={`home_project_div ${item.id === "r3" ? "r3" : ""}`}
                  style={{ backgroundImage: `url(${item.coverImg})` }}
                ></div>
              </a>
            ))}
          </div>
        )}
        {window.innerWidth >= 768 && (
          <div ref={gridRef} className="bentogrid">
            <div data-bento="2x1" className="item">
              <a href={`/projects/${gavinResidence.id}`}>
                <h2>{gavinResidence.name}</h2>
                <div
                  className="bento_wrapper"
                  style={{ backgroundImage: `url(${gavinResidence.coverImg})` }}
                ></div>
              </a>
            </div>

            <div data-bento="1x1" className="item ">
              <a href={`/projects/${coimbatoreElevation.id}`}>
                <h2>{coimbatoreElevation.name}</h2>
                <div
                  className="bento_wrapper r3"
                  style={{
                    backgroundImage: `url(${coimbatoreElevation.coverImg})`,
                  }}
                ></div>
              </a>
            </div>
            <div data-bento="1x2" className="item">
              <a href={`/projects/${globalCriticalCare.id}`}>
                <h2>{globalCriticalCare.name}</h2>
                <div
                  className="bento_wrapper"
                  style={{
                    backgroundImage: `url(${globalCriticalCare.images[6]})`,
                  }}
                ></div>
              </a>
            </div>
            <div data-bento="1x1" className="item">
              <a href={`/projects/${machoSaloon.id}`}>
                <h2>{machoSaloon.name}</h2>
                <div
                  className="bento_wrapper"
                  style={{ backgroundImage: `url(${machoSaloon.coverImg})` }}
                ></div>
              </a>
            </div>
            <div data-bento="1x1" className="item">
              <a href={`/projects/${miracleWedding.id}`}>
                <h2>{miracleWedding.name}</h2>
                <div
                  className="bento_wrapper"
                  style={{ backgroundImage: `url(${miracleWedding.coverImg})` }}
                ></div>
              </a>
            </div>
            <div data-bento="1x1" className="item">
              <a href={`/projects/${rajaVilla.id}`}>
                <h2>{rajaVilla.name}</h2>
                <div
                  className="bento_wrapper"
                  style={{ backgroundImage: `url(${rajaVilla.coverImg})` }}
                ></div>
              </a>
            </div>
          </div>
        )}
        <div className="all_projects_btn_div">
          <a href="/projects">
            <button>View All Projects</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomeProject;
